module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/website_desktop-c2d025454513f1c94f7524b8074b88fb.png";